import PropTypes from "prop-types";
import React from "react";
import Modal from "../../../../components/Modal";
import { Typography, Button, Box } from "@mui/material";
import makeStyles from "@mui/styles/makeStyles";
import { ArchiveOutlined } from "@mui/icons-material";

const useStyles = makeStyles(theme => ({
  titleIcon: {
    marginRight: theme.spacing(1.5)
  }
}));

// TODO: Dialog content will be implemented under separate ticket
const ArchiveRepositoryModal = ({ onOpenChange, open, onSubmit }) => {
  const classes = useStyles();
  return (
    <Modal
      dialogTitle={
        <Box display="flex">
          <ArchiveOutlined className={classes.titleIcon} />
          <Typography variant="h4" color="textPrimary">
            Archive File
          </Typography>
        </Box>
      }
      open={open}
      onClose={() => onOpenChange(false)}
      dialogContent={null}
      dialogActions={
        <>
          <Button
            color="primary"
            onClick={() => {
              onOpenChange(false);
            }}
          >
            Cancel
          </Button>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              onSubmit();
            }}
          >
            OK
          </Button>
        </>
      }
      maxWidth="xs"
    />
  );
};

ArchiveRepositoryModal.propTypes = {
  /**
   * True if the archive repository modal is open, false otherwise
   */
  open: PropTypes.bool,
  /**
   * Called when the archive repository modal is open or closed
   */
  onOpenChange: PropTypes.func,
  /**
   * Called when the user presses the OK button in the dialog
   */
  onSubmit: PropTypes.func,
  /**
   * The course that the archive file currently belongs to. If there is no course,
   * this value should be null.
   */
  associatedCourse: PropTypes.string
};

export default ArchiveRepositoryModal;
